module.exports = __webpack_public_path__ + "img/index-8.35a359a5.png";